export const sleep = (ms = 0) => {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

/** Validation */
export const validators = {
  email: (v: string) => {
    const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return pattern.test(v) || 'Please enter a valid email address'
  },
  required: (v: any) => !!v || 'This field is required',
}

// TODO add data object parser to extend the url (when or if needed at some point)
// export const getData = async function (url = '', data = {}) {
export const getData = async function (url = '') {
  const response = await fetch(url, {
    method: 'GET', // HTTP method
    headers: {
      'Content-Type': 'application/json', // Content type header
    },
    credentials: 'include',
  })

  // Check if the response is OK
  if (!response.ok) {
    throw await response.json()
  }

  return await response.json()
}

export const putData = async function (url = '', data = {}) {
  const response = await fetch(url, {
    method: 'PUT', // HTTP method
    headers: {
      'Content-Type': 'application/json', // Content type header
    },
    credentials: 'include',
    body: JSON.stringify(data), // Convert data to JSON string
  })

  // Check if the response is OK
  if (!response.ok) {
    throw await response.json()
  }

  return await response.json()
}

export const deleteData = async function (url = '') {
  const response = await fetch(url, {
    method: 'DELETE', // HTTP method
    headers: {
      'Content-Type': 'application/json', // Content type header
    },
    credentials: 'include',
  })

  // Check if the response is OK
  if (!response.ok) {
    throw await response.json()
  }

  return await response.json()
}

export const postData = async function (url = '', data = {}) {
  const response = await fetch(url, {
    method: 'POST', // HTTP method
    headers: {
      'Content-Type': 'application/json', // Content type header
    },
    credentials: 'include',
    body: JSON.stringify(data), // Convert data to JSON string
  })

  // Check if the response is OK
  if (!response.ok) {
    throw await response.json()
  }

  return await response.json()
}

export const getHashParam = function (paramName: string) {
  const hash = window.location.hash

  if (!hash.includes('?') || !hash.includes(paramName + '=')) {
    return null
  }

  return window.location.hash.split(paramName + '=')[1].split('&')[0]
}
export const getCookie = (name: string) => {
  return (
      document.cookie
          .split('; ')
          .find((row) => row.startsWith(name + '='))
          ?.split('=')[1] || null
  )
}

